import Nav from './components/Nav';

function App() {
  return (
    <div className='bg-[#000]'>
      <Nav />
    </div>
  );
}

export default App;
